// extracted by mini-css-extract-plugin
export var actions = "_um-4";
export var item = "_um-1";
export var price = "_um-3";
export var quantity = "_um-2";
export var table = "_um-0";